/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loading from '../../components/Loading';

import * as courseService from '../../services/courses';

import stylesLayout from '../../common/layout.module.scss';
import CoursesTable from '../../components/CoursesTable';

const CoursesModule = (
) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [courses, setcourses] = useState([]);

  const loadCourses = async () => {
    setLoading(true);
    const rsp = await courseService.all();
    if (rsp && rsp.status) {
      setcourses(rsp.data);
    }
    setLoading(false);
  };

  const onAction = (action, hash) => {
    switch (action) {
      case 'view':
        history.push(`/curso/${hash}`);
        break;
      default:
    }
  };

  useEffect(() => {
    loadCourses();
  }, []);

  if (loading) {
    return <div className={stylesLayout.page}><Loading /></div>;
  }

  // const stepsStore = getStepsStore(store);
  // const pendingStepsStore = (stepsStore.filter((x) => !x.completed));
  return (
    <div className={stylesLayout.page}>
      <div className={stylesLayout.title}>
        Cursos
        <div className={stylesLayout.secAction}>
          <Button onClick={() => { history.push('/curso/nuevo'); }}>
            <FontAwesomeIcon
              icon={faPlus}
              style={{ marginRight: 10 }}
            />
            Agregar
          </Button>
        </div>
      </div>
      <div className={stylesLayout.content}>
        <CoursesTable
          items={courses}
          onAction={onAction}
        />
      </div>
    </div>
  );
};

CoursesModule.propTypes = {
};

export default CoursesModule;
